import { ISODate } from '../../common/utils';

export const getRowHtmlAttributes = (
  valueDate: ISODate,
  isPastYear: boolean
) => {
  if (!isPastYear) {
    return;
  }

  const oneYearAgo = new Date();
  if (oneYearAgo.getDate() === 29) {
    oneYearAgo.setDate(28);
  }
  oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

  return {
    hidden: new Date(valueDate) < oneYearAgo,
  };
};
